// Select all elements with the class 'block--text'
const blockTextElements = document.querySelectorAll('.block--text');

// Iterate over the selected elements
blockTextElements.forEach(function(block) {
    // Select all <a> elements within the current .block--text element
    const linkElements = block.querySelectorAll('a');
    
    // Iterate over the <a> elements
    linkElements.forEach(function(link) {
        // Check if the <a> element does not have a tabindex attribute
        if (!link.hasAttribute('tabindex')) {
            // Set the tabindex attribute to 0
            link.setAttribute('tabindex', '0');
        }

        if (link.hasAttribute('target') && link.getAttribute('target') === '_blank') {
            // Set the tabindex attribute to 0
            link.setAttribute('aria-label', 'Open in nieuw tabblad');
        }
    });
});

function handleInput(e) {
    // If the user presses the Tab key, add the 'keyboard-only' class
    if (e.type === 'keydown' && e.key === 'Tab') {
      document.body.classList.add('keyboard-only');
      
      // Stop listening for 'keydown' events to prevent multiple triggers
      window.removeEventListener('keydown', handleInput);
      
      // Start listening for mouse clicks to remove the class when a mouse is used
      window.addEventListener('mousedown', handleInput);
    } 
    // If the user clicks the mouse, remove the 'keyboard-only' class
    else if (e.type === 'mousedown') {
      document.body.classList.remove('keyboard-only');
      
      // Stop listening for mouse events to prevent multiple triggers
      window.removeEventListener('mousedown', handleInput);
      
      // Start listening for Tab key usage again
      window.addEventListener('keydown', handleInput);
    }
}
  
// Start by listening for the Tab key usage
window.addEventListener('keydown', handleInput);

// loop trough each a.page-numbers and add a tabindex="0"
const pageNumbers = document.querySelectorAll('a.page-numbers');
const lang = document.querySelector('.check-current-lang-en') ? 'en' : 'nl';
pageNumbers.forEach(function(pageNumber) {
    pageNumber.setAttribute('tabindex', '0');
    pageNumber.setAttribute('aria-label', lang == 'nl' ? 'Naar pagina' : 'To page');

    if (pageNumber.classList.contains('prev')) {
        pageNumber.setAttribute('aria-label', 'Vorige pagina');
        pageNumber.setAttribute('aria-label', lang == 'nl' ? 'Vorige pagina' : 'Previous page');
    }

    if (pageNumber.classList.contains('next')) {
        pageNumber.setAttribute('aria-label', 'Volgende pagina');
        pageNumber.setAttribute('aria-label', lang == 'nl' ? 'Volgende pagina' : 'Next page');
    }
});
